import React from 'react';
import PropTypes from 'prop-types';
import { Link, LinkProps } from 'gatsby';

export function LinkButton({ color, to, className, children, ...props }) {
  const classes = `px-5 py-3 text-center text-${color}-800 bg-${color}-100 hover:bg-${color}-200 hover:text-${color}-900 rounded-md ${className}`;

  return (
    <Link to={to} className={classes} {...props}>
      {children}
    </Link>
  );
}

LinkButton.propTypes = {
  color: PropTypes.oneOf(['gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink']),
  ...LinkProps,
};

LinkButton.defaultProps = {
  color: 'indigo',
};
